import {
  useState,
  useEffect,
  useRef,
  useContext,
  useCallback,
  useLayoutEffect,
} from "react"
import { selectChain } from "components/Stacker/actions/AmuletStackerActions"
import { toggleModal } from "components/Stacker/actions/ModalActions"
import { getProductDetails } from "components/Stacker/actions/ProductDetailActions"
import {
  //addRefiner,
  setLoadStatus,
  setRearrangeStatus,
  setStackerLoadStatus,
  setStackerReadyStatus,
  showProductInfoPanel,
  stackerReset,
} from "components/Stacker/actions/StackerActions"
import classNames from "classnames"
import QuickViewModal from "components/Stacker/components/QuickViewModal/QuickViewModal"
import ModalConfig from "components/Stacker/config/ModalConfig"
import isMobile from "components/Stacker/utils/device-check"
import PropTypes from "prop-types"
import queryString from "query-string"
import InfoBox from "../../Common/InfoBox/InfoBox"
import { flattenSVG } from "../../Common/svg-to-paths"
import { hitTest } from "../../../utils/helpers/helpers"
import IntroBox from "../AmuletIntroBox/AmuletIntroBox"
import AmuletItem from "../AmuletItem/AmuletItemF"
import AmuletStackerNecklace from "../AmuletStackerNecklace/AmuletStackerNecklace"
import "./AmuletStacker.scss"
import AmuletStackerHelpControls from "./AmuletStackerControls/AmuletStackerHelpControls"
import AmuletStackerNavControls from "./AmuletStackerControls/AmuletStackerNavControls"
import { shadowDOM } from "components/Stacker/utils/shadowDOM"
import StackerConstants from "components/Stacker/constants/StackerConstants"
import { shallowEqual, useDispatch } from "react-redux"
import { StackerContext } from "components/DYStackers/StackerContext"
import { useLocation } from "react-router"
import { useNavigate } from "react-router-dom"
import { useSelector } from "react-redux"
import { gsap, CSSPlugin } from "gsap/all"
import ApiUtils from "components/Stacker/api"

gsap.registerPlugin(CSSPlugin)

const tChainPositions = [[0.38], [0.38, 0.62], [0.38, 0.62], [0.62]]
const tChainRearrangePositions = [[0.21], [0.21, 0.8], [0.21, 0.8, 0.8]]
const positions = [
  /* 1 */ [0.5],
  /* 2 */ [0.48, 0.52],
  /* 3 */ [0.46, 0.5, 0.54],
  /* 4 */ [0.44, 0.48, 0.52, 0.56],
  /* 5 */ [0.42, 0.46, 0.5, 0.54, 0.58],
  /* 6 */ [0.4, 0.44, 0.48, 0.52, 0.56, 0.6],
  /* 7 */ [0.38, 0.42, 0.46, 0.5, 0.54, 0.58, 0.62],
]
const rearrangePositions = [
  /* 1 */ [0.5],
  /* 2 */ [0.42, 0.58],
  /* 3 */ [0.38, 0.5, 0.62],
  /* 4 */ [0.3, 0.43, 0.57, 0.7],
  /* 5 */ [0.24, 0.36, 0.5, 0.64, 0.78],
  /* 6 */ [0.14, 0.28, 0.43, 0.57, 0.72, 0.86],
  /* 7 */ [0.12, 0.23, 0.38, 0.5, 0.63, 0.77, 0.88],
]
const vehiclePositions = [
  /* 1 */ [0.5],
  /* 2 */ [0.42, 0.58],
  /* 3 */ [0.35, 0.5, 0.65],
]
const vehicleRearrangePositions = [
  /* 1 */ [0.5],
  /* 2 */ [0.3, 0.7],
  /* 3 */ [0.18, 0.5, 0.82],
]
function AmuletStacker({ onHelpClick, onShareClick }) {
  const dispatch = useDispatch()
  const location = useLocation()
  const navigate = useNavigate()
  const products = useSelector((state) => state.stacker.products, shallowEqual)
  const stackerContext = useContext(StackerContext)

  const isAppLoaded = useSelector((state) => state.stacker.isAppLoaded)
  const isDataLoading = useSelector((state) => state.search.meta.isDataLoading)
  //const isRearrange = useSelector((state) => state.stacker.isRearrange)
  const [isRearrange, setisRearrange] = useState(false)

  const isReviewing = useSelector((state) => state.stacker.isReviewing)
  const isStackerLoaded = useSelector((state) => state.stacker.isStackerLoaded)
  const isStackerReady = useSelector((state) => state.stacker.isStackerReady)
  const selectedProduct = useSelector(
    (state) => state.amuletStacker.productInfo
  )

  const [chain, setChain] = useState(null)
  const [chainVariant, setChainVariant] = useState(null)
  //const [amuletsReady, updatedAmuletsReady] = useState([])
  //const [products, setProducts] = useState([])
  const [chainLoaded, setChainLoaded] = useState(false)
  const [isVehicle, setIsVehicle] = useState(false)
  const [pdpLoaded, setPdpLoaded] = useState(false)
  const [amuletsLoaded, setAmuletsLoaded] = useState(false)
  //const [pdpAmuletsLoaded, setPdpAmuletsLoaded] = useState(false)
  const [loadAmulets, setLoadAmuletsState] = useState(false)
  //const [pathData, setPathData] = useState({ point: { x: 0, y: 0 }, edge: 0 })
  const pathData = useRef({ point: { x: 0, y: 0 }, edge: 0 })

  const [scale, setScale] = useState(1)
  const pathRef = useRef()
  const draggedEdge = useRef(0)
  const mousePosition = useRef({ x: 0, y: 0 })
  const sortables = useRef([])
  const animatedTo = useRef({})

  //const [paths, setPaths] = useState([])
  const paths = useRef([])
  const svgRef = useRef()
  const containerRef = useRef()
  const DeepRef = gsap.utils.selector(containerRef)
  //const [isDragging, setIsDragging] = useState(false)
  const [shouldDelay, setShouldDelay] = useState(false)
  const pendingPdp = useRef([])
  const pdp = useSelector(
    (state) => state.pdp,
    (prev, next) => {
      for (const pid of pendingPdp.current) {
        if (pid in next) {
          if (!(pid in prev)) {
            return false
          }
        }
        if (pid in prev) {
          if (!(pid in next)) {
            return false
          }
        }
      }

      return true
    }
  )

  const setSortables = useCallback(
    (items) => {
      const newSortables = []

      const size = isVehicle ? Math.min(3, items.length) : items.length

      for (let i = 0; i < size; i++) {
        const exists = sortables.current.findIndex(
          (item) => item.item === items[i]
        )
        newSortables.push({
          index: i,
          item: items[i],
          pos: 0,
          isNew: exists < 0,
        })
      }
      sortables.current = newSortables
    },
    [isVehicle]
  )

  const getQueryProducts = useCallback(() => {
    const queryObj = queryString.parse(location.search, { decode: true })
    let queryProducts = []
    if (queryObj.products) {
      queryProducts = Array.isArray(queryObj.products)
        ? queryObj.products.map((product) => product.replace(/-/, " "))
        : [queryObj.products.replace(/-/, " ")]
    }
    return queryProducts
  }, [location.search])

  const [selected, setSelected] = useState(getQueryProducts())

  useLayoutEffect(() => {
    // Filter querystring of invalid product or variant codes
    const queryObj = queryString.parse(location.search, { decode: true })
    let queryProducts = []

    if (!queryObj.products) {
      // Nothing to validate
      return
    }

    queryProducts = queryObj.products

    let productIdStack = queryProducts
    const queryParams = {
      baseStore: pdp.queryParams.baseStore,
    }
    var queryParamsString = queryString.stringify(
      { ...queryObj, products: productIdStack },
      { encode: true }
    )

    validateNextProduct(queryProducts, queryParamsString, 0, false)
    function validateNextProduct(
      queryProducts,
      queryParamsString,
      i,
      invalidProductFound
    ) {
      let item = queryProducts
      if (Array.isArray(queryProducts)) {
        item = queryProducts[i]
      }
      var itemSearch = item.replace("-", " ")
      const url = `v1/retailer/${stackerContext.retailerId}/product/${itemSearch}`
      ApiUtils.makeAjaxRequest(
        {
          url: url,
          queryParams,
        },
        (res) => {
          // Empty result => product not found
          if (!res) {
            invalidProductFound = true
            productIdStack = queryProducts.filter((p) => {
              return p != item
            })
            queryParamsString = queryString.stringify(
              { ...queryObj, products: productIdStack },
              { encode: true }
            )
            console.log("Product not found " + item)
          }

          if (i + 1 == queryProducts.length) {
            if (invalidProductFound) {
              navigate(`${location.pathname}?${queryParamsString}`)
              window.location.reload() // Force refresh the state of the stacker
            }
          } else {
            validateNextProduct(
              queryProducts,
              queryParamsString,
              i + 1,
              invalidProductFound
            )
          }
        },
        (err) => {
          console.log("Failed to fetch amulet product for validation " + err)
        }
      )
    }
  }, [products, location])

  useLayoutEffect(() => {
    const queryObj = queryString.parse(location.search, { decode: true })
    const {
      chainBaseProduct: queryChain,
      chainVariantCode: queryChainVariant,
    } = queryObj
    setChain(queryChain)
    setChainVariant(queryChainVariant)
    const products = getQueryProducts()
    if (!shallowEqual(products, selected)) {
      setSelected(products)
    } else {
      if (!products.every((prod, i) => prod === selected[i])) {
        setSelected(products)
      }
    }
  }, [dispatch, getQueryProducts, location.search, selected])

  useEffect(() => {
    if (!chain) {
      return
    }
    if (!pdp[chain] && !pendingPdp.current.includes(chain)) {
      dispatch(
        getProductDetails({
          args: { productId: chain },
          retailerId: stackerContext.retailerId,
        })
      )
      pendingPdp.current.push(chain)
    }
  }, [chain, dispatch, pdp, stackerContext.retailerId])

  useEffect(() => {
    if (!chainVariant) {
      return
    }
    if (!pdp[chainVariant] && !pendingPdp.current.includes(chainVariant)) {
      dispatch(
        getProductDetails({
          args: { productId: chainVariant },
          retailerId: stackerContext.retailerId,
        })
      )
      pendingPdp.current.push(chainVariant)
    }
  }, [chainVariant, dispatch, pdp, stackerContext.retailerId])

  const setPdpAmuletsLoadStatus = useCallback((status, isReady) => {
    //setPdpAmuletsLoaded(status)
  }, [])

  useEffect(() => {
    if (!pdp[chain] || !pdp[chainVariant]) {
      return
    }

    if (pdpLoaded) {
      return
    }

    if (!pdp[chain].data) {
      return
    }

    const {
      data: {
        products: { productId },
      },
      meta: { width },
    } = pdp[chain]

    const { isVehicle } = pdp[chain].meta.isVehicle
    const isVariantVehicle = pdp[chainVariant].meta.isVehicle
    const isReallyVehicle = isVehicle || isVariantVehicle

    let realWidth = width
    if (!width) {
      realWidth = pdp[chainVariant].meta.width
    }

    dispatch(
      selectChain({
        chainBaseProduct: productId,
        chainVariantCode: chainVariant,
        thickness: realWidth,
      })
    )
    setIsVehicle(isReallyVehicle)
    setPdpLoaded(true)
  }, [chain, chainVariant, dispatch, pdp, pdpLoaded])

  const onChangeChainClick = useCallback(() => {
    const instance = stackerContext.getInstance()
    const queryObj = queryString.parse(location.search, { decode: true })
    const queryParamsString = queryString.stringify(
      { products: queryObj.products },
      {
        encode: true,
      }
    )
    navigate(`${instance.amuletRoute}?${queryParamsString}`)
  }, [location.search, navigate, stackerContext])

  const onChainImageLoad = useCallback(() => {
    setChainLoaded(true)
  }, [])

  const onRearrange = useCallback((updatedAmulets) => {
    const queryObj = queryString.parse(location.search, { decode: true })
    const origQueryString = queryString.stringify(queryObj, { encode: true })
    queryObj.products = updatedAmulets
    const queryParamsString = queryString.stringify(queryObj, {
      encode: true,
    })
    if (queryParamsString !== origQueryString) {
      navigate(`${location.pathname}?${queryParamsString}`)
    }
    // eslint-disable-next-line prettier/prettier
  }, [])

  const onMove = useCallback((e) => {
    const x = e.clientX || e.touches[0].clientX || undefined
    const y = e.clientY || e.touches[0].clientY || undefined
    mousePosition.current = { x, y }

    const offsetY = isMobile() ? 55 : 100
    const rect = containerRef.current.getBoundingClientRect()
    const m = { x: x - rect.x - 40, y: y - offsetY }
    const { points } = paths.current[0]
    const { point, edge, rot } = hitTest(m, points)
    pathData.current = { point, edge: edge / points.length, rot }
  }, [])

  const getEdge = useCallback(() => {
    return pathData.current.edge
  }, [])

  const getAnimatedToPosition = useCallback((id) => {
    const startIndex = sortables.current.findIndex((p) => p.item === id) //selected.indexOf(id)
    id = id.replace("-", " ")
    return animatedTo.current[id] ?? -1 // sortables.current[startIndex].pos
  }, [])

  const swapSortable = (indexA, indexB) => {
    const a = { ...sortables.current[indexA] }
    const b = { ...sortables.current[indexB] }
    sortables.current[indexA].item = b.item
    sortables.current[indexB].item = a.item
    const rotation = a.pos < b.pos ? 180 : 0
    gsap.to(DeepRef(`#amulet${b.item.replace(/ /, "-")}`)[0], {
      ease: "power4.out",
      duration: 0.5,
      scale,
      motionPath: {
        align: DeepRef("#pathChain")[0],
        alignOrigin: [0.5, 0.07],
        autoRotate: rotation,
        end: a.pos,
        path: DeepRef("#pathChain")[0],
        start: b.pos,
      },
    })
    animatedTo.current[b.item] = a.pos
    console.log(`swap ${b.item} to ${a.pos}`)
  }

  const onDragEnd = useCallback(
    (id) => {
      const comparableId = id.replace("-", " ")
      const newProducts = sortables.current.map((item) => item.item)
      const startIndex = sortables.current.findIndex(
        (p) => p.item === comparableId
      ) //selected.indexOf(id)
      const pos = sortables.current[startIndex].pos
      const pos_from = draggedEdge.current
      const rotation = pos < pos_from ? 180 : 0
      gsap.to(DeepRef(`#amulet${id.replace(/ /, "-")}`)[0], {
        ease: "power4.out",
        duration: 0.3,
        scale,
        motionPath: {
          align: DeepRef("#pathChain")[0],
          alignOrigin: [0.5, 0.07],
          autoRotate: rotation,
          end: pos,
          path: DeepRef("#pathChain")[0],
          start: pos_from,
        },
      })
      animatedTo.current[comparableId] = pos
      draggedEdge.current = pos
      onRearrange(newProducts)
    },
    [onRearrange]
  )

  const onDrag = useCallback(
    (id, itemEdge) => {
      // const newPositions =
      //   chain === StackerConstants.T_CHAIN &&
      //   chainVariant === StackerConstants.T_CHAIN_VARIANT
      //     ? tChainRearrangePositions
      //     : rearrangePositions
      draggedEdge.current = itemEdge
      //let removedAmulets = []
      //const tempAmulets = [...selected]
      const comparableId = id.replace("-", " ")
      const startIndex = sortables.current.findIndex(
        (p) => p.item === comparableId
      ) //selected.indexOf(id)
      const positions = sortables.current.map((sortable) => sortable.pos) // newPositions[selected.length - 1]
      for (let i = 0; i < positions.length; i++) {
        if (itemEdge < positions[i] && i < startIndex) {
          //removedAmulets = tempAmulets.splice(startIndex, 1)
          //tempAmulets.splice(i, 0, ...removedAmulets)
          //onRearrange(tempAmulets)
          swapSortable(startIndex, i)
          break
        } else if (itemEdge > positions[i] && i > startIndex) {
          //removedAmulets = tempAmulets.splice(startIndex, 1)
          //tempAmulets.splice(i, 0, ...removedAmulets)
          //onRearrange(tempAmulets)
          swapSortable(startIndex, i)
          break
        }
      }
    },
    [chain, chainVariant, selected]
  )

  const onRearrangeClick = useCallback(() => {
    setShouldDelay(false)
    //dispatch(setRearrangeStatus(!isRearrange))
    sortables.current = sortables.current.map((sortable) => ({
      ...sortable,
      isNew: false,
    }))
    setisRearrange((value) => {
      if (!value) {
        animatedTo.current = {}
      }
      return !value
    })
  }, [])

  const getAmuletProduct = (id) => {
    const pdpId = id.replace(/-/, " ")
    const pdpBaseId = id.substring(0, 9) // Base Product

    let amulet = pdp[pdpBaseId]
    if (!amulet) {
      console.log("undefined amulet")
    }
    // Get Variant Product
    else if (pdpBaseId !== pdpId) {
      amulet.data.products.variantOptions.forEach((variant) => {
        if (variant.id === pdpId) {
          amulet = variant
        }
      })
    }

    return amulet
  }

  const setReady = (status) => {
    if (isStackerReady !== status) {
      dispatch(setStackerReadyStatus(status))
    }
  }

  useEffect(() => {
    let ready = true
    let loaded = true
    selected &&
      selected.forEach((item) => {
        const baseProductItem = item.substr(0, 9)
        if (!pdp[baseProductItem]) {
          loaded = false
          if (!pendingPdp.current.includes(baseProductItem)) {
            dispatch(
              getProductDetails({
                args: { productId: baseProductItem },
                retailerId: stackerContext.retailerId,
              })
            )
            pendingPdp.current.push(baseProductItem)
            ready = false
          }
        }
        if (!pdp[item]) {
          loaded = false
          if (!pendingPdp.current.includes(item)) {
            dispatch(
              getProductDetails({
                args: { productId: item },
                retailerId: stackerContext.retailerId,
              })
            )
            pendingPdp.current.push(item)
            ready = false
          }
        }
      })

    if (ready !== isStackerLoaded) {
      //setReady(ready)
      setPdpAmuletsLoadStatus(!ready, ready)
    }
  }, [
    dispatch,
    pdp,
    selected,
    setPdpAmuletsLoadStatus,
    stackerContext.retailerId,
  ])

  const setAmuletsScale = useCallback((scale) => {
    setScale(scale * 5)
  }, [])

  const onNecklaceResize = useCallback(
    (scale) => {
      setAmuletsScale(scale)
    },
    [setAmuletsScale]
  )

  const setLoadAmulets = useCallback(() => {
    //setTimeout(() => setLoadAmuletsState(true), 100)
    //if (!loadAmulets) {
    setLoadAmuletsState(true)
    //}
  }, [])

  useEffect(() => {
    if (
      pdpLoaded &&
      chainLoaded &&
      !isAppLoaded &&
      !isDataLoading &&
      !isStackerLoaded
    ) {
      dispatch(setStackerLoadStatus(true))
    }
  }, [
    chainLoaded,
    dispatch,
    isAppLoaded,
    isDataLoading,
    isStackerLoaded,
    pdpLoaded,
  ])

  useEffect(() => {
    const amuletsPendingReady = selected.filter((item) => {
      return !!pdp[item.replace(/-/, " ")]
    })
    if (
      isAppLoaded &&
      amuletsPendingReady.length === selected.length &&
      selected.length > 0
    ) {
      //setLoadAmulets()
      setLoadAmuletsState(true)
    } else {
      setLoadAmuletsState(false)
    }
  }, [isAppLoaded, pdp, selected])

  useLayoutEffect(() => {
    const onWindowResize = () => {
      paths.current = flattenSVG(svgRef.current)
    }
    window.addEventListener("resize", onWindowResize)
    const m = shadowDOM.getElementById("mainContentArea")
    m.classList.remove("bg-gray")
    m.classList.add("bg-white")

    paths.current = flattenSVG(svgRef.current, { maxError: 0 })
    return () => {
      window.removeEventListener("resize", onWindowResize)
    }
  }, [dispatch])

  useEffect(() => {
    return () => {
      dispatch(setLoadStatus(false))
      dispatch(stackerReset())
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    setShouldDelay(true)
  }, [selected.length])

  const createAmulet = (
    product,
    id,
    to = 0.5,
    update = false,
    isNew = true
  ) => {
    let src = ""
    if (product.imageURL) {
      src = `${product.imageURL}_STACKER.png`
    } else if (product.data) {
      src = `${product.data.products.imageURL}_STACKER.png`
    } else {
      return
    }

    let delay = 0
    if (shouldDelay) {
      delay = update ? 0.4 : 0
    }

    console.log(`Setting ${id} to ${to} updating ${update}`)

    // const src = `${product.data.products.imageURL}_STACKER.png`
    // console.log(`creating amuletitem [${id}]`)
    return (
      <AmuletItem
        delay={delay}
        duration={0.75}
        dispatch={dispatch}
        id={id}
        isNew={isNew}
        isRearrange={isRearrange}
        isVehicle={isVehicle}
        key={id.replace(/ /, "-")}
        scale={scale}
        src={src}
        to={to}
        onDrag={onDrag}
        onDragEnd={onDragEnd}
        location={location}
        navigate={navigate}
        getEdge={getEdge}
        getAnimatedTo={getAnimatedToPosition}
        pathId={DeepRef("#pathChain")[0]}
      />
    )
  }

  const getAmuletPositions = () => {
    if (
      chain === StackerConstants.T_CHAIN &&
      chainVariant === StackerConstants.T_CHAIN_VARIANT
    ) {
      return tChainPositions
    }
    return isVehicle ? vehiclePositions : positions
  }

  const getAmuletRearrangePositions = () => {
    if (
      chain === StackerConstants.T_CHAIN &&
      chainVariant === StackerConstants.T_CHAIN_VARIANT
    ) {
      return tChainRearrangePositions
    }
    return isVehicle ? vehicleRearrangePositions : rearrangePositions
  }

  const getPos = () => {
    return isRearrange ? getAmuletRearrangePositions() : getAmuletPositions()
  }

  // useEffect(() => {
  //   const positionByIndex = getPos()[sortables.current.length - 1]
  //   if (!positionByIndex) {
  //     return
  //   }
  //   for (let i = 0; i < sortables.current.length; i++) {
  //     sortables.current[i].pos = positionByIndex[i]
  //   }
  // }, [isRearrange])

  const amuletsComponents = () => {
    if (selected.length === 0) {
      return null
    }
    // if (selected.length !== sortables.current.length) {
    //   setSortables(selected)
    // }
    // const positionByIndex = getPos()[sortables.current.length - 1]

    // if (!positionByIndex) {
    //   console.log("need positions...")
    // }

    let loaded = true
    sortables.current.forEach((sortable) => {
      try {
        const item = sortable.item
        const baseProductItem = item.substr(0, 9)
        if (!pdp[baseProductItem]) {
          loaded = false
        }
        if (!pdp[item]) {
          loaded = false
        }
      } catch (ex) {
        console.log("oh oh")
      }
    })

    if (!loaded) {
      return null
    }

    const positionByIndex = getPos()[sortables.current.length - 1]
    if (!positionByIndex) {
      return
    }
    for (let i = 0; i < sortables.current.length; i++) {
      sortables.current[i].pos = positionByIndex[i]
    }

    return sortables.current.map((sortable, i) => {
      const amulet = sortable.item
      //const to = positionByIndex[i]
      const product = getAmuletProduct(amulet)
      //sortable.pos = to
      const element = createAmulet(
        product,
        amulet.replace(/ /, "-"),
        sortable.pos,
        true,
        sortable.isNew
      )
      sortable.isNew = false
      return element
    })
  }

  useEffect(() => {
    if (!selected || !selected.length) {
      setSortables([])
      return
    }

    setSortables(selected)
  }, [selected, setSortables])

  const hasProducts = selected.length > 0
  const showInfoBox = selectedProduct.pid !== ""
  const stackedAmulets = loadAmulets ? amuletsComponents() : null
  const necklace = pdp[chainVariant]
  const stackerClasses = classNames(
    "stacker",
    { rearrange: isRearrange },
    { vehicle: isVehicle }
  )

  const handleMouseMove = isRearrange ? onMove : null

  return (
    <div
      className="container-amulets flex-grow-1 position-relative white-gradient-background"
      ref={containerRef}
      onMouseMove={handleMouseMove}
      onTouchMove={handleMouseMove}
    >
      {!hasProducts && <IntroBox />}
      <div className={stackerClasses}>
        {necklace && necklace.selectedVariant && (
          <AmuletStackerNecklace
            productCode={necklace.selectedVariant}
            imageUrl={`${necklace.selectedVariant.imageURL}_STACKER`}
            onChainImageLoad={onChainImageLoad}
            onProductResize={onNecklaceResize}
          />
        )}
        <div className="chain chain-svg" id="chain-svg">
          {isVehicle ? (
            <svg viewBox="0 0 770.11401 283.28101" ref={svgRef}>
              <path
                d="m 337.1661,158.80448 c 0,0 2.66794,36.02115 38.92823,35.65165 36.26028,-0.36948 36.85266,-35.65165 36.85266,-35.65165"
                ref={pathRef}
                id="pathChain"
                fill="none"
                stroke="#000000"
                strokeOpacity="0"
                strokeWidth={5}
                transform=" translate(10) scale(1)"
              />
            </svg>
          ) : (
            <svg viewBox="0 0 770.11401 283.28101" ref={svgRef}>
              <path
                d="m 165.09053,0.04137568 c 0,0 79.2532,240.68565432 210.22951,249.74378432 C 506.29635,258.84329 586.68265,54.537126 602.80245,0.42410566"
                id="pathChain"
                ref={pathRef}
                fill="none"
                stroke="#000000"
                strokeOpacity="0"
                strokeWidth={5}
                transform=" translate(10) scale(1)"
              />
            </svg>
          )}
        </div>
        <div className="stacked-amulets">{stackedAmulets}</div>
      </div>
      {(!isMobile() || (isMobile() && !isRearrange)) && (
        <AmuletStackerHelpControls
          onChangeChainClick={onChangeChainClick}
          onHelpClick={onHelpClick}
          onShareClick={onShareClick}
        />
      )}
      <AmuletStackerNavControls
        hasProducts={hasProducts}
        isReviewing={isReviewing}
        onChangeChainClick={onChangeChainClick}
        onRearrangeClick={onRearrangeClick}
        rearrange={isRearrange}
      />
      <QuickViewModal />
    </div>
  )
}

AmuletStacker.propTypes = {
  onHelpClick: PropTypes.func.isRequired,
  onShareClick: PropTypes.func,
}

export default AmuletStacker
